
<template>
  <div class="page">
    <div class="container-fluid pt-2 contenu-page">
      <div id="modalWait">
        <Modal :showModal="waiting" class="modal-clir-demo-blue" :closable="false" :closeButton="false">
          <template #header>Traitement en cours</template>
          <template #body>
            <div class="w-100 text-center">
              <div>
                <i>patientez SVP...</i>
              </div>
              <div class="spinner-border text-clir-demo-blue mt-2" role="status">
                <span class="visually-hidden">En cours de traitement, patientez SVP...</span>
              </div>
            </div>
          </template>
        </Modal>
      </div>

      <div id="modalAides"> 
        <Modal
        :showModal="afficheAideSpi"
        :closeButton="false"
        centered
        >
            <template #body>
                <img src="../../assets/img/aideSPI.png" class="afficheAide"/>
                <div style="padding-top:50px;">
                <p style="font-size:14px;">
                  Le numéro fiscal est l'identifiant unique pour toutes les démarches fiscales. Il est composé de 13 caractères numériques. Il est situé à gauche dans le cadre <strong>Vos références</strong>.
                </p>
                </div>
            </template>
            <template #footer>
            <button class="btn btn-bleu me-2" @click="afficheAideSpi=false">Fermer</button>
            </template>
      </Modal>
      
      
      
      <Modal
        :showModal="afficheAideFact"
        :closeButton="false"
        centered
        >
            <template #body>
                <img src="../../assets/img/aideFacture.png" class="afficheAide"/>
                <div style="padding-top:50px;">
                <p style="font-size:14px;">
                  La référence de l'avis est un identifiant fiscal qui permet de retrouver l'avis d'impôt concerné par le document présenté par l'usager. Il est composé de 13 caractères aplhanumériques ou 14 caractères pour un avis de dégrèvement. Il est situé en haut à gauche de l'avis dans le cadre <strong>Vos références</strong>.
                </p>
                </div>
            </template>
            <template #footer>
            <button class="btn btn-bleu me-2" @click="afficheAideFact=false">Fermer</button>
            </template>
      </Modal>
      </div>
      
      <div class="container bg-verifavis p-3">
        <h1 class="titre-bienvenue bleu">
        Bienvenue sur le service de vérification des avis
        </h1>
      Le service permet de vérifier qu'il s'agit du dernier avis d'impôt sur les revenus. <br />
      <br /> 
      <h4 class="bleu">Accès au service de vérification </h4>
      <br />
      Saisissez les identifiants  <br /> 
        <div class="erreur">{{ zonesObligatoires }}</div>
      <br />
      <form
        id="form1"
        :class="'needs-validation ${wasSubmitted}'"
        novalidate
        @reset="clearFields()"
      >
        <div class="row">
          <div class="col-md-3">
            <label for="numFiscal" class="form-label">Numéro fiscal*</label>
          </div>
        </div>
        <div class="row mb-1_1 align-items-center">
          <div class="col-6 col-md-4 col-lg-3">
            <input   v-model="numFiscal"   type="text"  name="numFiscal"
              :class="'input-form ${numFiscalClass}'"
              id="numFiscal" required  maxlength=19 />
          </div>
          <div class="col-3 col-md-2 col-lg-1">
            <button class="btn-aide me-2" type="button" @click="afficheAideSpi=true">?</button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <label for="reference" class="form-label">Référence de l'avis*</label>
          </div>
        </div>
        <div class="row mb-1_1 align-items-center">
          <div class="col-6 col-md-4 col-lg-3">
            <input   v-model="reference"   type="text"   name="reference" 
            :class="'input-form ${referenceClass}'" 
            id="reference" required maxlength=20 />
          </div>
          <div class="col-3 col-md-2 col-lg-1">
            <button class="btn-aide me-2" type="button" @click="afficheAideFact=true">?</button>
          </div>
        </div>
        <div class="row row align-items-center" v-show="erreurIdentifiants">
          <div class="col-lg1 col-md-1 col-2"><img src="../../assets/img/attention.gif"/></div>
          <div class="erreur col-lg-11 col-md-11 col-10">Vous devez vérifier les identifiants saisis. Il peut s'agir d'une erreur de saisie ou ces identifiants ne correspondent pas à un avis.</div>
        </div>
      <br />
      *données obligatoires  <br />  <br /> 
        <div class="container">
          <div class="d-flex mb-1_1 justify-content-end">
            <div>
              <button class="btn btn-bleu me-2" type="button" @click="formSubmit()">Valider</button>
            </div>
          </div>
        </div>
      </form>  
      </div>
      <br/>
      </div>
      <div class="bas-page">© Ministère de l'Économie, des Finances et de la Souveraineté industrielle et numérique</div>
  </div>
</template>


<script>
import Modal from "@/clir/components/Modal/Modal";

const baseURL = `${process.env.VUE_APP_APPLICATION_NAME}/api`;

//https://getbootstrap.com/docs/4.0/components/forms/
//https://fr.vuejs.org/v2/guide/forms.html
//https://fr.vuejs.org/v2/cookbook/form-validation.html

/**
 * Page de présentation des fonctionnalités de validation de formulaires
 *
 *
 * @author <span><span class="fw-bold">Cyrille Goyette</span><a class="ms-2" href="mailto:cyrille.goyette@dgfip.finances.gouv.fr">cyrille.goyette@dgfip.finances.gouv.fr</a></span>
 * @since Version 1.0
 * @version 1.2
 */
export default {
  name: "Formulaire",
  data() {
    return {
      numFiscal: "",
      reference: "",
      errors: {
        numFiscal: "Numéro fiscal invalide, veuillez saisir 13 chiffres",
        reference:
          "Référence invalide, veuillez saisir au moins 2 lettres sans accent"
      },
      regExps: {
        numFiscal: new RegExp(/^[0-9]{13,13}$/),
        reference: new RegExp(/^[a-zA-Z0-9]{13,14}$/)
      },
      empties: {
        numFiscal: "Veuillez saisir votre numéro fiscal",
        reference: "Veuillez saisir la référence de l'avis"
      },
      wasSubmitted: false,
      validClass: "is-valid",
      invalidClass: "is-invalid",
      value: "",
      waiting: false,
      respok: false,
      respjson: {},
      erreurIdentifiants: false,
      zonesObligatoires: "",
      afficheAideSpi:false,
      afficheAideFact:false
    };
  },
  computed: {

    numFiscalValidationTest() {
      console.log(this.numFiscal);
      console.log(this.numFiscal.replace(/\s/g, ''));
      console.log(this.validationTest(this.numFiscal.replace(/\s/g, ''), this.regExps["numFiscal"]));
      return this.validationTest(this.numFiscal.replace(/\s/g, ''), this.regExps["numFiscal"]);
    },

    referenceValidationTest() {
      console.log(this.reference);
      console.log(this.reference.replace(/\s/g, ''));
      console.log(this.validationTest(this.reference.replace(/\s/g, ''), this.regExps["reference"]));
      return this.validationTest(this.reference.replace(/\s/g, ''), this.regExps["reference"]);
    },

    numFiscalClass() {
      return this.validationInputTextClass(this.numFiscal, this.regExps["numFiscal"]);
    },

    referenceClass() {
      return this.validationInputTextClass(this.reference, this.regExps["reference"]);
    },

    numFiscalInvalidComment() {
      return this.validationInputTextComment(this.numFiscal, "numFiscal");
    },

    referenceInvalidComment() {
      return this.validationInputTextComment(this.reference, "reference");
    },
    isFormValid() {
      return (

        this.numFiscalValidationTest &&
        this.referenceValidationTest
      );
    },
    reqJson() {
      return JSON.stringify({


        numFiscal: this.numFiscal,
        reference: this.reference,
      });
    }
  },
  methods: {
    validationTest(text, regexp) {
      return this.wasSubmitted && regexp.test(text.trim());
    },
    validationInputTextClass(text, regexp) {
      return this.wasSubmitted
        ? text.trim().length && this.validationTest(text, regexp)
          ? this.validClass
          : this.invalidClass
        : "";
    },
    validationInputTextComment(text, field) {
      return this.wasSubmitted
        ? text.trim().length
          ? this.errors[field]
          : this.empties[field]
        : "";
    },
    clearFields() {
      this.wasSubmitted = false;
      this.numFiscal = "";
      this.reference = "";
    },
    formSubmit() {
      this.erreurIdentifiants=false;
      this.zonesObligatoires="";
      this.respok = false;
      this.wasSubmitted = true;
      if (!this.isFormValid) {
        if(this.numFiscal == '' || this.reference == '' )
        {
          this.zonesObligatoires="La saisie de toutes les zones est obligatoire.";
          this.numFiscal="";
          this.reference="";  
        }
        else
        {
          this.erreurIdentifiants=true;
          this.numFiscal="";
          this.reference="";       
        }
        return false;
      }

      this.waiting = true;
      const payload = {
        url: `${baseURL}/verifavisback/spi/`+this.numFiscal.replace(/\s/g, '')+'/numavis/'+this.reference.replace(/\s/g, ''),
        options: {
          method: "GET",
          headers: [["Content-Type", "application/json"]]//,
          //body: this.reqJson
        }
      };
      this.DGFiPFetch(payload)
        .then(response => {
          if (response.error) {
            //alert("Une erreur est survenue: " + response.error);
           // this.waiting = false;
            //return false;
             this.$router.push({ name: 'Erreur'});
          }
          this.clearFields();
          this.waiting = false;

          this.respok = true;

          response.json().then(data => {
            this.respjson = data;
            var nomPage="";

            if(this.respjson.conforme)
            {
              nomPage='Conforme';
            }
            else
            {
              nomPage='NonConforme';
            }

            this.$router.push({ name: nomPage, params: { message: this.respjson.message, codeReponse: this.respjson.codeReponse}});
          });
        })
        .catch(e => {
          this.waiting = false;
          //this.pushError(e);

          if(e.status == 400) //SPI invalide
          {
            this.erreurIdentifiants=true;
            this.numFiscal="";
            this.reference="";     
          }
          else //erreur technique
          {
            this.$router.push({ name: 'Erreur'});
          }

          return false;
        });
    }
  },
  mounted() {
    this.clearFields();
  },
  components: { Modal }
};
</script>

<style>
form {
  text-align: left !important;
}
.open > .dropdown-menu {
  display: block;
}
.erreur {
  color: red;
}
.bg-verifavis{
  border-style: solid;
  border-color: #5D90C7;
}
.titre-bienvenue{
  width: 100%;
  margin-bottom: 1.25rem;
  font-weight: 700;
}
.bleu{
  color: #5D90C7;
}
.input-form{
    border-color: #5D90C7;
    background-color: #FFFFFF;
    border-color: #5D90C7;
    display: block;
    width: 96%;
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0;
}
.input-form:focus{
    background-color: #dce7f7;
    
}
.btn-aide{
    padding: 0 .4rem;
    font-size: .8rem;
    color: #000000;
    border-radius: 50%;
    border-width: thin;
    background-color: #FFFFFF;
}
.btn-bleu {
    background-color: #5D90C7;
    color: #FFFFFF;
}

.afficheAide {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;

}

div#modalAides .modal-content {
    background-color:#ebf5fb;  
}

div#modalAides .modal-dialog {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

div#modalWait .modal-dialog {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.page{
  width: 100%;
  height: 100%;
  min-height: inherit;
  display: flex;
  flex-direction: column;
}
.contenu-page {
  margin: auto;
}
.bas-page {
  border-top: 1px solid #9e9e9e;
  font-size: 80%;
  color: #9e9e9e;
  text-align: center;
  width: 100%;
}
</style>